"use strict";
import ReactUtils from "../../react_utils";
import DocumentTitle from "react-document-title";
import { History } from "react-router";
import ToDashboardWithFilters from "../ui/to_dashboard_with_filters";
import Api from "../../api/api";
const bem = ReactUtils.makeBem("review-groups");
var ReviewGroups = React.createClass({
  mixins: [History],
  propTypes: {
    documentBatchId: React.PropTypes.number.isRequired,
    groups: React.PropTypes.array.isRequired,
    location: React.PropTypes.object.isRequired
  },
  getInitialState: function() {
    return {
      submitting: false
    };
  },
  debtorName: function(debtorName) {
    if (debtorName) {
      return debtorName;
    } else {
      return "No debtor selected";
    }
  },
  invoiceNumber: function(sourceInvoiceNumber) {
    if (sourceInvoiceNumber) {
      return sourceInvoiceNumber;
    } else {
      return "Not found";
    }
  },
  standardGroupDisplay: function(group) {
    return /* @__PURE__ */ React.createElement("div", { key: group.id }, /* @__PURE__ */ React.createElement("h4", null, `Group ${group.number}`), /* @__PURE__ */ React.createElement("div", { className: bem("__typeahead-label-inline") }, /* @__PURE__ */ React.createElement("span", { className: "group-field" }, "Invoice #:"), /* @__PURE__ */ React.createElement("span", { className: "group-value" }, this.invoiceNumber(group.sourceInvoiceNumber))), /* @__PURE__ */ React.createElement("div", { className: bem("__typeahead-label-inline") }, /* @__PURE__ */ React.createElement("span", { className: "group-field" }, "Debtor:"), /* @__PURE__ */ React.createElement("span", { className: "group-value" }, this.debtorName(group.debtorName))), group.documents.length > 0 ? group.documents.map((document, index) => {
      return /* @__PURE__ */ React.createElement("div", { key: document.id, className: bem("__typeahead-label-inline") }, /* @__PURE__ */ React.createElement("span", { className: "group-field" }, "Document ", index + 1, ":"), /* @__PURE__ */ React.createElement("span", { className: "group-value" }, document["data"]["document_type"]));
    }) : /* @__PURE__ */ React.createElement("div", { className: bem("__typeahead-label-inline") }, /* @__PURE__ */ React.createElement("span", { className: "group-field" }), /* @__PURE__ */ React.createElement("span", { className: "group-value" }, "No Documents")), /* @__PURE__ */ React.createElement("hr", null));
  },
  unassociatedGroupDisplay: function(group) {
    const possiblePluralizedDocument = group.documents.length === 1 ? "Document" : "Documents";
    return /* @__PURE__ */ React.createElement("div", { key: "unassociated" }, /* @__PURE__ */ React.createElement("h4", null, `Unassociated`), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", { className: "group-value" }, group.documents.length, " ", possiblePluralizedDocument)), /* @__PURE__ */ React.createElement("hr", null));
  },
  handleSubmit: function(event) {
    event.stopPropagation();
    event.preventDefault();
    this.setState({ submitting: true });
    Api.DocumentBatches.markInvoicesIndexedAndSendTransmission(this.props.documentBatchId).then(() => {
      ToDashboardWithFilters(this.props.location, this.history);
    });
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "TriumphPay Audit \u2013 Review Invoices" }, /* @__PURE__ */ React.createElement("div", { className: bem("") }, /* @__PURE__ */ React.createElement("h3", null, "Review"), /* @__PURE__ */ React.createElement("button", { onClick: this.handleSubmit, disabled: this.state.submitting, className: "review-groups__submit" }, "Submit"), /* @__PURE__ */ React.createElement("hr", null), this.props.groups.map((group) => {
      if (group.number === "unassociated") {
        return this.unassociatedGroupDisplay(group);
      } else {
        return this.standardGroupDisplay(group);
      }
    })));
  }
});
export default ReviewGroups;
